import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { URLS } from 'src/app/constants/URLS';
import { debounceTime, map, switchMap } from 'rxjs/operators';

export function uniqueUsernameValidator(
  http: HttpClient,
  updateProfile: () => boolean
): AsyncValidatorFn {
  return (control: AbstractControl) => {
    if (updateProfile()) {
      return of(null);
    }
    const value = control.value;
    if (!value || value.length < 5) {
      return of(null);
    }
    return of(value).pipe(
      debounceTime(500),
      switchMap((username) =>
        http.get<any>(`${URLS.uniqueUser}?user_name=@${encodeURIComponent(username)}`)
      ),
      map((res) => {
        return res?.data !== 'true' ? { usernameTaken: true } : null;
      })
    );
  };
}